import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Checkbox from '../../../../components/Checkbox/Checkbox';
import { I18Text } from '../../../../components/i18Next/I18Text';
import CheckMark from '../../../../components/SVGIcons/CheckMark';
import { useStores } from '../../../../stores/useStores';

import classes from './TermsAndServices.module.scss';

const TERMS_OF_SEVICE = '/pages/terms-of-service';
const PRIVACY_POLICY = '/pages/privacy-policy';

interface Props {
  isTermsAccepted: boolean;
  isError: boolean;
  setIsTermsAccepted: (value: boolean) => void;
}

export function TermsAndServices({ isTermsAccepted, isError, setIsTermsAccepted }: Props) {
  const { t } = useTranslation();
  const { liveGeoStore } = useStores();
  const { territoryLegalAge } = liveGeoStore.currentGeo ?? {};
  const legalAge = territoryLegalAge || 18;
  return (
    <div className={classes.termsRow}>
      <div className={classes.checkboxWrapper}>
        <Checkbox
          checked={isTermsAccepted}
          className={classNames(classes.checkbox, { [classes.checkboxError]: isError })}
          dataTestId="signup-service-terms-btn"
          icon={<CheckMark />}
          id="terms-confirmation"
          required={true}
          onChange={setIsTermsAccepted}
        />
      </div>
      <I18Text
        className={classes.termsLabel}
        components={{
          linkTextPrivacyPolicy: (
            <a className={classes.termsLink} href={PRIVACY_POLICY} rel="noreferrer" target="_blank">
              {t('auth.privacyPolicy')}
            </a>
          ),
          linkTextTermsService: (
            <a className={classes.termsLink} href={TERMS_OF_SEVICE} rel="noreferrer" target="_blank">
              {t('auth.termsOfService')}
            </a>
          ),
        }}
        i18nKey="auth.termsAndPrivacy"
        values={{ legalAge }}
      />
    </div>
  );
}
